<template>
  <div
    class="root-menu"
    :class="{ 'menu-pinned': menuPinned, 'menu-expanded': menuExpanded }"
  >
    <!-- PC端顶部触发条：菜单收起后仅剩此条，悬浮弹出；钉子点击后颜色变深并固定菜单 -->
    <div
      class="menu-trigger-bar"
      @mouseenter="expandMenu"
      @click="togglePin"
    >
      <span class="pin-icon" :class="{ 'pin-active': menuPinned }">📌</span>
      <span class="trigger-title">菜单</span>
    </div>

    <div
      class="menu-panel"
      @mouseenter="expandMenu"
      @mouseleave="onPanelLeave"
    >
    <header class="header">
      <div class="header-container">
        <div class="logo-section">
          <h1 class="company-name">北京利康科技有限公司</h1>
          <h2 class="platform-name">专注保健食品行业，提供专业的批文转让、清理换证、注册备案及研发服务。</h2>
        </div>

        <!-- PC端用户区域 -->
        <div class="pc-user-section">
          <!-- 欢迎用户名 - 仅在登录时显示 -->
          <div v-if="userInfo" class="welcome-user">
            <span class="welcome-text">欢迎，</span>
            <span class="username">{{ userInfo.username }}</span>
          </div>

          <!-- 头像和下拉菜单 -->
          <el-dropdown @command="handleUserCommand" trigger="click">
            <div class="avatar-wrapper" title="用户菜单">
              <img v-if="userInfo && displayAvatar" :src="displayAvatar" class="user-avatar" alt="头像" />
              <el-icon v-else :size="24" color="#fff">
                <User />
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <template v-if="userInfo">
                  <!-- 我的批文库 / 我的好友（位于退出/登录上方） -->
                  <el-dropdown-item command="myLibraries">
                    <span>📚 我的批文库</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="myFriends">
                    <span>👥 我的文友</span>
                  </el-dropdown-item>
                  <!-- 管理员专属功能 -->
                  <template v-if="isAdmin">
                    <el-dropdown-item command="pzwhRecognize">
                      <span>批文识别</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="adminChat">
                      <span>管理对话</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="wxmpList">
                      <span>公众号列表</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="solarTerms">
                      <span>节气管理</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="searchRule">
                      <span>批文查找规则</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="accessRule">
                      <span>访问规则管理</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="blacklist">
                      <span>黑名单管理</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="accessLog">
                      <span>访问日志</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="gzhSendlist">
                      <span>公众号往期文章</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="faqManager">
                      <span>常见流程管理</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="industryHotManager">
                      <span>行业热点管理</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="pwzrManage">
                      <span>批文转让维护</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="customerBrowse">
                      <span>客户浏览列表</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="editProfile">
                      <span>👤 个人信息修改</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="logout" divided>
                      <el-icon><SwitchButton /></el-icon>
                      <span>退出</span>
                    </el-dropdown-item>
                  </template>
                  <template v-else>
                    <el-dropdown-item command="editProfile">
                      <span>👤 个人信息修改</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="resetPassword">
                      <el-icon><Key /></el-icon>
                      <span>重置密码</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="logout" divided>
                      <el-icon><SwitchButton /></el-icon>
                      <span>退出</span>
                    </el-dropdown-item>
                  </template>
                </template>
                <template v-else>
                  <el-dropdown-item command="login">
                    <el-icon><User /></el-icon>
                    <span>登录</span>
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>

        <!-- 移动端汉堡菜单按钮 -->
        <button
          class="hamburger-menu"
          @click="toggleMobileMenu"
          :aria-expanded="mobileMenuOpen.toString()"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>

    <!-- 桌面端导航 -->
    <nav class="nav-desktop">
      <div class="nav-buttons">
        <a @click="navigateTo('/')" class="nav-button" :class="{ 'nav-button-active': isNavActive('/') }">
          <span class="button-text">保健食品数据库</span>
        </a>
         <a @click="navigateTo('/dashboard')" class="nav-button" :class="{ 'nav-button-active': isNavActive('/dashboard') }">
          <span class="button-text">保健食品数据看板</span>
        </a>
        <a @click="navigateTo('/internationalSearch')" class="nav-button" :class="{ 'nav-button-active': isNavActive('/internationalSearch') }">
          <span class="button-text">国际保健食品查询</span>
        </a>
        <a @click="navigateTo('/doubleNoList')" class="nav-button" :class="{ 'nav-button-active': isNavActive('/doubleNoList') }">
          <span class="button-text">保健食品清理换证</span>
        </a>
        <a @click="navigateTo('/pwzrList')" class="nav-button" :class="{ 'nav-button-active': isNavActive('/pwzrList') }">
          <span class="button-text">保健食品批文转让</span>
        </a>
        <a @click="navigateTo('/spdtList')" class="nav-button" :class="{ 'nav-button-active': isNavActive('/spdtList') }">
          <span class="button-text">保健食品批文决定书</span>
        </a>
        <a @click="navigateTo('/changeRegistration')" class="nav-button" :class="{ 'nav-button-active': isNavActive('/changeRegistration') }">
          <span class="button-text">保健食品变更注册</span>
        </a>
        <a @click="navigateTo('/marketing')" class="nav-button" :class="{ 'nav-button-active': isNavActive('/marketing') }">
          <span class="button-text">保健食品交易平台</span>
        </a>
        <a @click="navigateTo('/aboutUs')" class="nav-button" :class="{ 'nav-button-active': isNavActive('/aboutUs') }">
          <span class="button-text">关于我们</span>
        </a>
        <a v-if="isAdmin" @click="navigateTo('/adminChat')" class="nav-button" :class="{ 'nav-button-active': isNavActive('/adminChat') }">
          <span class="button-text">管理员聊天</span>
        </a>
      </div>
    </nav>
    </div>

    <!-- 移动端导航 -->
    <nav class="nav-mobile" :class="{ 'nav-mobile-open': mobileMenuOpen }">
      <div class="nav-buttons-mobile">
        <a
          @click="navigateTo('/')"
          class="nav-button-mobile"
        >
          <span class="button-text">保健食品数据库</span>
        </a>
        <a
          @click="navigateTo('/dashboard')"
          class="nav-button-mobile"
        >
          <span class="button-text">保健食品数据看板</span>
        </a>



        <a
          @click="navigateTo('/internationalSearch')"
          class="nav-button-mobile"
        >




        
          <span class="button-text">国际保健食品查询</span>
        </a>
        <a
          @click="navigateTo('/doubleNoList')"
          class="nav-button-mobile"
        >
          <span class="button-text">保健食品清理换证</span>
        </a>
        <a
          @click="navigateTo('/pwzrList')"
          class="nav-button-mobile"
        >
          <span class="button-text">保健食品批文转让</span>
        </a>
        <a
          @click="navigateTo('/spdtList')"
          class="nav-button-mobile"
        >
          <span class="button-text">保健食品批文决定书</span>
        </a>
        <a
          @click="navigateTo('/changeRegistration')"
          class="nav-button-mobile"
        >
          <span class="button-text">保健食品变更注册</span>
        </a>
        <a
          @click="navigateTo('/marketing')"
          class="nav-button-mobile"
        >
          <span class="button-text">保健食品交易平台</span>
        </a>
        <a
          @click="navigateTo('/aboutUs')"
          class="nav-button-mobile"
        >
          <span class="button-text">关于我们</span>
        </a>
        <a v-if="isAdmin" @click="navigateTo('/adminChat')" class="nav-button-mobile">
            <span class="button-text">管理员聊天</span>
        </a>

        <!-- 移动端用户菜单项 -->
        <div class="mobile-user-menu">
          <!-- 移动端欢迎信息 -->
          <div v-if="userInfo" class="mobile-welcome-user">
            <el-icon><User /></el-icon>
            <span class="mobile-username">{{ userInfo.username }}</span>
          </div>

          <template v-if="userInfo">
            <a href="javascript:;" class="nav-button-mobile" @click="navigateTo('/myLibraries')">
              <span>📚 我的批文库</span>
            </a>
            <a href="javascript:;" class="nav-button-mobile" @click="navigateTo('/myLibraries?openFriends=1')">
              <span>👥 我的文友</span>
            </a>
            <a
              href="javascript:;"
              class="nav-button-mobile"
              @click="handleResetPassword"
            >
              <el-icon><Key /></el-icon>
              <span>重置密码</span>
            </a>
            <a href="javascript:;" class="nav-button-mobile" @click="handleLogout">
              <el-icon><SwitchButton /></el-icon>
              <span>退出</span>
            </a>
          </template>
          <template v-else>
            <a href="javascript:;" class="nav-button-mobile" @click="handleLogin">
              <el-icon><User /></el-icon>
              <span>登录</span>
            </a>
          </template>
        </div>
      </div>
    </nav>

    <!-- 移动端菜单遮罩 -->
    <div
      class="mobile-menu-overlay"
      :class="{ 'overlay-open': mobileMenuOpen }"
      @click="closeMobileMenu"
    ></div>

    <!-- 批文识别对话框 - 仅管理员可见 -->
    <PzwhChatDialog ref="pzwhChatDialog" />

    <!-- 个人信息修改对话框 -->
    <el-dialog v-model="profileDialogVisible" title="个人信息修改" width="480px" append-to-body>
      <div class="profile-body">
        <div class="profile-avatar-row">
          <img :src="profileForm.avatarPreview" class="profile-avatar-preview" alt="头像预览" />
          <div class="profile-avatar-actions">
            <el-button size="small" @click="triggerProfileAvatarUpload">更换头像</el-button>
            <div class="profile-avatar-tip">支持 jpg/jpeg/png/gif/webp，大小不超过5M</div>
          </div>
          <input ref="profileAvatarInput" type="file" accept="image/jpeg,image/png,image/gif,image/webp" style="display:none" @change="onProfileAvatarChange" />
        </div>

        <el-form label-width="90px">
          <el-form-item label="昵称">
            <el-input v-model="profileForm.nickname" maxlength="100" placeholder="请输入昵称" />
          </el-form-item>
          <el-form-item label="单位">
            <el-input v-model="profileForm.company" maxlength="100" placeholder="请输入单位名称" />
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="profileForm.gender" @change="onProfileGenderChange">
              <el-radio value="male">男</el-radio>
              <el-radio value="female">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="修改密码">
            <el-radio-group v-model="profileForm.changePassword">
              <el-radio :value="false">否</el-radio>
              <el-radio :value="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="profileForm.changePassword">
            <el-form-item label="原密码">
              <el-input v-model="profileForm.oldPassword" type="password" show-password placeholder="请输入原密码" />
            </el-form-item>
            <el-form-item label="新密码">
              <el-input v-model="profileForm.newPassword" type="password" show-password placeholder="6-20位，含大小写字母和数字" />
            </el-form-item>
            <el-form-item label="确认密码">
              <el-input v-model="profileForm.confirmPassword" type="password" show-password placeholder="请再次输入新密码" />
            </el-form-item>
          </template>
        </el-form>
      </div>
      <template #footer>
        <el-button @click="profileDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="profileSaving" @click="saveProfile">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import { onMounted, onBeforeUnmount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axios from 'axios'
import config from '../config.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import {
  User,
  Key,
  SwitchButton
} from '@element-plus/icons-vue'
import PzwhChatDialog from './PzwhChatDialog.vue'

const router = useRouter()
const route = useRoute()
const userInfo = ref(null)

// 菜单弹出/收起/钉子（PC端）
const menuExpanded = ref(true)
const menuPinned = ref(false)
const isPC = ref(typeof window !== 'undefined' ? window.innerWidth > 768 : true)
let collapseTimer = null

const navigateTo = (path) => {
  router.push(path)
  closeMobileMenu()
}

const isAdmin = computed(() => {
  if (!userInfo.value) return false

  // 根据 role 字段判断
  if (userInfo.value.role === 'admin') {
    return true
  }

  // 根据用户名判断（兼容旧数据）
  if (userInfo.value.username) {
    const username = userInfo.value.username.toLowerCase()
    return username === 'admin' ||
           username === 'administrator' ||
           username.startsWith('admin_')
  }

  return false
})

// 批文识别对话框
const pzwhChatDialog = ref(null)

// 头像展示URL：自定义头像走 /api/avatar/ 需拼API前缀；无头像时统一用默认女头像（与好友列表一致）
const DEFAULT_AVATAR = '/static/image/profilePhoto/defaultWoman.jpg'
const resolveAvatarUrl = (avatar) => {
  if (!avatar) return DEFAULT_AVATAR
  if (avatar.startsWith('http')) return avatar
  if (avatar.startsWith('/api/')) return config.API_BASE_URL + avatar
  return avatar
}

const displayAvatar = computed(() => {
  if (!userInfo.value) return ''
  return resolveAvatarUrl(userInfo.value.avatar)
})

// 获取用户信息：token 存在时向后端校验真实身份；
// 校验失败（缓存残留/token过期）则清除本地缓存，不再显示"欢迎xxx"
const getUserInfo = async () => {
  const token = localStorage.getItem('token')
  if (!token) {
    userInfo.value = null
    return
  }
  try {
    const resp = await axios.get(`${config.API_BASE_URL}/api/user/current`, {
      headers: { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` }
    })
    if (resp.data && resp.data.code === 200) {
      userInfo.value = resp.data.data
      localStorage.setItem('userInfo', JSON.stringify(resp.data.data))
    } else {
      clearLocalUser()
    }
  } catch (e) {
    clearLocalUser()
  }
}

// 无实质用户标识时清除本地缓存（欢迎用户名随之消失）
const clearLocalUser = () => {
  userInfo.value = null
  localStorage.removeItem('userInfo')
  // token 失效也一并清理，页面统一显示"登录"入口
  localStorage.removeItem('token')
}

// 当前路由对应的导航按钮高亮
const isNavActive = (path) => {
  const current = route.path
  if (path === '/') {
    return current === '/' || current.startsWith('/detail')
  }
  return current === path || current.startsWith(path + '/')
}

// PC端菜单交互：进入页面先弹出，随后收起；悬浮顶部弹出；钉子固定
const expandMenu = () => {
  if (!isPC.value) return
  menuExpanded.value = true
  if (collapseTimer) {
    clearTimeout(collapseTimer)
    collapseTimer = null
  }
}

const onPanelLeave = () => {
  if (!isPC.value || menuPinned.value) return
  menuExpanded.value = false
}

const togglePin = () => {
  menuPinned.value = !menuPinned.value
  if (menuPinned.value) {
    menuExpanded.value = true
  }
}

const scheduleCollapse = () => {
  if (!isPC.value) return
  collapseTimer = setTimeout(() => {
    if (!menuPinned.value) {
      menuExpanded.value = false
    }
  }, 1500)
}

// 用户菜单命令处理
const handleUserCommand = (command) => {
  switch (command) {
    case 'login':
      handleLogin()
      break
    case 'myLibraries':
      navigateTo('/myLibraries')
      break
    case 'myFriends':
      // 进入我的批文库页并自动滑出好友侧边栏
      navigateTo('/myLibraries?openFriends=1')
      break
    case 'editProfile':
      openProfileDialog()
      break
    case 'resetPassword':
      handleResetPassword()
      break
    case 'pzwhRecognize':
      handlePzwhRecognize()
      break
    case 'adminChat':
      navigateTo('/adminChat')
      break
    case 'wxmpList':
      navigateTo('/wxmpList')
      break
    case 'solarTerms':
      navigateTo('/solar-terms')
      break
    case 'searchRule':
      navigateTo('/admin/search-rule')
      break
    case 'accessRule':
      navigateTo('/admin/access-rule')
      break
    case 'blacklist':
      navigateTo('/admin/blacklist')
      break
    case 'accessLog':
      navigateTo('/admin/access-log')
      break
    case 'gzhSendlist':
      navigateTo('/admin/gzh-sendlist')
      break
    case 'faqManager':
      navigateTo('/admin/faq')
      break
    case 'industryHotManager':
      navigateTo('/admin/industry-hot')
      break
    case 'pwzrManage':
      navigateTo('/admin/pwzr-manage')
      break
    case 'customerBrowse':
      navigateTo('/admin/customer-browse')
      break
    case 'logout':
      handleLogout()
      break
  }
}

// 登录处理
const handleLogin = () => {
  closeMobileMenu()
  const isWxMini = /miniProgram/i.test(navigator.userAgent)
  if (isWxMini) {
    // 小程序环境：直接跳转原生登录页
    if (window.wx && window.wx.miniProgram) {
      window.wx.miniProgram.navigateTo({ url: '/pages/login/login' })
    }
    return
  }
  router.push({
    name: 'login',
    query: {
      redirectTo: router.currentRoute.value.fullPath
    }
  })
}

// 重置密码处理
const handleResetPassword = () => {
  closeMobileMenu()
  router.push({ name: 'resetPassword' })
}

// 个人信息修改：头像（上传预览）+ 昵称 + 单位 + 性别 + 修改密码（单选框是/否，默认否）
const profileDialogVisible = ref(false)
const profileSaving = ref(false)
const profileAvatarInput = ref(null)
const profileAvatarFile = ref(null)
const profileForm = ref({
  nickname: '',
  company: '',
  gender: 'female',
  changePassword: false,
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
  avatarPreview: DEFAULT_AVATAR
})

const openProfileDialog = () => {
  const u = userInfo.value || {}
  profileAvatarFile.value = null
  profileForm.value = {
    nickname: u.nickname || '',
    company: u.company || '',
    gender: u.gender || 'female',
    changePassword: false,
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    avatarPreview: resolveAvatarUrl(u.avatar)
  }
  profileDialogVisible.value = true
}

const triggerProfileAvatarUpload = () => {
  if (profileAvatarInput.value) profileAvatarInput.value.click()
}

const onProfileAvatarChange = (e) => {
  const file = e.target.files && e.target.files[0]
  e.target.value = ''
  if (!file) return
  if (file.size > 5 * 1024 * 1024) {
    ElMessage.warning('头像图片大小不能超过5M')
    return
  }
  profileAvatarFile.value = file
  profileForm.value.avatarPreview = URL.createObjectURL(file)
}

// 切换性别且未选择新头像时，预览跟随默认头像变化
const onProfileGenderChange = (gender) => {
  if (!profileAvatarFile.value) {
    profileForm.value.avatarPreview = gender === 'male'
      ? '/static/image/profilePhoto/defautMan.jpg'
      : '/static/image/profilePhoto/defaultWoman.jpg'
  }
}

const authHeader = () => {
  const token = localStorage.getItem('token')
  return token ? { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` } : {}
}

const saveProfile = async () => {
  const form = profileForm.value
  if (form.changePassword) {
    if (!form.oldPassword) {
      ElMessage.warning('请输入原密码')
      return
    }
    if (!form.newPassword) {
      ElMessage.warning('请输入新密码')
      return
    }
    if (form.newPassword !== form.confirmPassword) {
      ElMessage.warning('两次输入的新密码不一致')
      return
    }
  }
  profileSaving.value = true
  try {
    // 1. 修改密码（勾选"是"时）
    if (form.changePassword) {
      const pwdResp = await axios.post(`${config.API_BASE_URL}/api/user/changePassword`, {
        oldPassword: form.oldPassword,
        newPassword: form.newPassword
      }, { headers: authHeader() })
      if (pwdResp.data.code !== 200) {
        ElMessage.error(pwdResp.data.message || '密码修改失败')
        return
      }
    }
    // 2. 上传新头像（选择了新头像时）
    let avatarUrl = null
    if (profileAvatarFile.value) {
      const formData = new FormData()
      formData.append('file', profileAvatarFile.value)
      const avatarResp = await axios.post(`${config.API_BASE_URL}/api/user/avatar`, formData, {
        headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' }
      })
      if (avatarResp.data.code !== 200) {
        ElMessage.error(avatarResp.data.message || '头像上传失败')
        return
      }
      avatarUrl = avatarResp.data.data.avatar
    }
    // 3. 保存个人资料（未换头像但切换性别时，后端按性别同步默认头像）
    const profilePayload = {
      nickname: form.nickname.trim(),
      company: form.company.trim(),
      gender: form.gender
    }
    if (avatarUrl) {
      profilePayload.avatar = avatarUrl
    }
    const profileResp = await axios.post(`${config.API_BASE_URL}/api/user/profile`, profilePayload, {
      headers: authHeader()
    })
    if (profileResp.data.code !== 200) {
      ElMessage.error(profileResp.data.message || '保存失败')
      return
    }
    // 更新本地用户信息与菜单展示
    const data = profileResp.data.data || {}
    if (userInfo.value) {
      userInfo.value.nickname = data.nickname
      userInfo.value.company = data.company
      userInfo.value.gender = data.gender
      userInfo.value.avatar = data.avatar
    }
    const cached = localStorage.getItem('userInfo')
    if (cached) {
      try {
        const u = JSON.parse(cached)
        u.nickname = data.nickname
        u.company = data.company
        u.gender = data.gender
        u.avatar = data.avatar
        localStorage.setItem('userInfo', JSON.stringify(u))
      } catch (err) { /* ignore */ }
    }
    ElMessage.success(form.changePassword ? '密码与个人信息已保存' : '个人信息已保存')
    profileDialogVisible.value = false
  } catch (e) {
    ElMessage.error(e.response?.data?.message || '保存失败，请重试')
  } finally {
    profileSaving.value = false
  }
}

// 批文识别处理
const handlePzwhRecognize = () => {
  if (pzwhChatDialog.value) {
    pzwhChatDialog.value.openDialog()
  }
}

// 退出登录
const handleLogout = async () => {
  try {
    // 确认对话框
    await ElMessageBox.confirm(
      '确定要退出登录吗？',
      '退出确认',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    )
    
    const token = localStorage.getItem('token')
    
    if (token) {
      const cleanToken = token.replace('Bearer ', '').trim()
      await axios.post(`${config.API_BASE_URL}/api/outlogout`, null, {
        headers: {
          'Authorization': `Bearer ${cleanToken}`
        }
      })
    }
    
    // 清除本地存储
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    userInfo.value = null
    
    ElMessage.success('退出成功')
    
    // 关闭移动端菜单
    closeMobileMenu()
    
    // 跳转到首页
    router.push('/')
    
  } catch (error) {
    // 如果用户点击取消，不做任何操作
    if (error === 'cancel') {
      return
    }
    console.error('退出失败:', error)
    ElMessage.error('退出失败，请重试')
  }
}

onMounted(() => {
  getUserInfo()
  if (isPC.value) {
    // PC端：进入页面菜单先弹出，1.5秒后自动收起到顶部
    menuExpanded.value = true
    scheduleCollapse()
  }
  window.addEventListener('resize', onResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
  if (collapseTimer) clearTimeout(collapseTimer)
})

const onResize = () => {
  const nowPC = window.innerWidth > 768
  if (nowPC !== isPC.value) {
    isPC.value = nowPC
    menuExpanded.value = true
    menuPinned.value = false
  }
}

// 移动端菜单状态
const mobileMenuOpen = ref(false)

// 切换移动端菜单
const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
  if (mobileMenuOpen.value) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
}

// 关闭移动端菜单
const closeMobileMenu = () => {
  mobileMenuOpen.value = false
  document.body.style.overflow = ''
}
</script>
<style scoped>
/* 新增样式 */

/* PC端用户区域 */
.pc-user-section {
  margin-left: auto;
  display: flex;
  align-items: center;
  margin-right: 15px;
  gap: 15px;
}

/* 欢迎用户信息 */
.welcome-user {
  display: flex;
  align-items: center;
  color: white;
  font-size: 14px;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.welcome-text {
  color: rgba(255, 255, 255, 0.9);
  margin-right: 5px;
}

.username {
  color: white;
  font-weight: 500;
}

/* 齿轮图标 */
.gear-icon-wrapper {
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.1);
}

.gear-icon-wrapper:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: rotate(45deg);
}

.gear-icon {
  transition: transform 0.3s ease;
}

/* 下拉菜单样式优化 */
:deep(.el-dropdown-menu) {
  min-width: 140px;
  margin-top: 5px;
}

:deep(.el-dropdown-menu__item) {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  font-size: 14px;
}

:deep(.el-dropdown-menu__item .el-icon) {
  font-size: 16px;
  width: 16px;
}

/* 移动端用户菜单 */
.mobile-user-menu {
  margin-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 15px;
}

/* 移动端欢迎信息 */
.mobile-welcome-user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  margin-bottom: 10px;
  font-size: 16px;
}

.mobile-welcome-user .el-icon {
  font-size: 20px;
  color: #409eff;
}

.mobile-username {
  font-weight: 500;
}

.mobile-user-menu .nav-button-mobile {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-start;
  background: #409eff;
  margin-bottom: 8px;
  padding: 12px 15px;
}

.mobile-user-menu .nav-button-mobile .el-icon {
  font-size: 18px;
  width: 18px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .pc-user-section {
    display: none;
  }
  
  .mobile-user-menu {
    display: block;
  }
}

@media (min-width: 769px) {
  .mobile-user-menu {
    display: none;
  }
  
  .pc-user-section {
    display: flex;
  }
}

/* 原有样式保持不变 */
.root-menu {
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* PC端顶部触发条（菜单收起后悬浮此处弹出） */
.menu-trigger-bar {
  display: none;
  height: 30px;
  background: linear-gradient(135deg, #0056b3, #0083c9);
  color: #fff;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  user-select: none;
}

.pin-icon {
  font-size: 14px;
  opacity: 0.75;
  transition: all 0.25s ease;
  padding: 2px 6px;
  border-radius: 50%;
}

.pin-icon.pin-active {
  background: rgba(0, 0, 0, 0.35);
  opacity: 1;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.trigger-title {
  letter-spacing: 2px;
}

/* 菜单面板：收起时滑到顶部，仅剩触发条 */
.menu-panel {
  overflow: hidden;
  transition: max-height 0.35s ease, opacity 0.3s ease;
}

.root-menu.menu-expanded .menu-panel {
  max-height: 500px;
  opacity: 1;
}

.root-menu:not(.menu-expanded) .menu-panel {
  max-height: 0;
  opacity: 0;
}

/* 导航按钮选中态：颜色变化 */
.nav-button-active,
.nav-button-active:hover {
  background: #0056b3 !important;
  box-shadow: inset 0 -3px 0 #ffd04b, 0 3px 6px rgba(0, 0, 0, 0.12) !important;
  transform: translateY(-2px);
}

/* 头像 */
.avatar-wrapper {
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.85);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
}

.avatar-wrapper:hover {
  border-color: #fff;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

.user-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 个人信息修改对话框 */
.profile-body {
  padding: 4px 0;
}

.profile-avatar-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f0f2f5;
}

.profile-avatar-preview {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e4e7ed;
  background: #f5f7fa;
}

.profile-avatar-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
}

.profile-avatar-tip {
  font-size: 12px;
  color: #909399;
}

.header {
  background: linear-gradient(135deg, #0056b3, #0083c9);
  padding: 15px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.logo-section {
  display: flex;
  align-items: center;
  color: white;
  flex-wrap: wrap;
}

.company-name {
  font-size: 24px;
  margin-right: 10px;
  margin-bottom: 0;
  line-height: 1.2;
}

.platform-name {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 0;
  line-height: 1.2;
}

/* 汉堡菜单按钮 */
.hamburger-menu {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.hamburger-menu span {
  display: block;
  height: 3px;
  width: 100%;
  background-color: white;
  border-radius: 3px;
  transition: all 0.3s ease;
}

/* 桌面端导航 */
.nav-desktop {
  background: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  width: 100%;
}

.nav-buttons {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  padding: 15px 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.nav-button {
  background: #0083c9;
  color: white;
  border: none;
  border-radius: 30px;
  padding: 12px 25px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.nav-button:hover {
  background: #0056b3;
  transform: translateY(-2px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.15);
}

/* 移动端导航 */
.nav-mobile {
  position: fixed;
  top: 0;
  right: -100%;
  width: 80%;
  max-width: 300px;
  height: 100vh;
  background: white;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease;
  z-index: 1001;
  padding-top: 80px;
  overflow-y: auto;
}

.nav-mobile-open {
  right: 0;
}

.nav-buttons-mobile {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.nav-button-mobile {
  background: #0083c9;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  text-align: center;
  display: block;
}

.nav-button-mobile:hover {
  background: #0056b3;
}

/* 移动端菜单遮罩 */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
}

.overlay-open {
  opacity: 1;
  visibility: visible;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .header-container {
    padding: 0 15px;
  }
  
  .nav-buttons {
    padding: 15px;
  }
  
  .nav-button {
    padding: 10px 20px;
    font-size: 15px;
  }
  
  .welcome-user {
    max-width: 150px;
  }
}

@media (max-width: 992px) {
  .logo-section {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .company-name {
    font-size: 22px;
    margin-right: 0;
    margin-bottom: 5px;
  }
  
  .platform-name {
    font-size: 16px;
  }
  
  .nav-buttons {
    gap: 8px;
  }
  
  .nav-button {
    padding: 8px 16px;
    font-size: 14px;
  }
  
  .welcome-user {
    font-size: 13px;
    max-width: 120px;
  }
}

@media (max-width: 768px) {
  .header {
    padding: 10px 0;
  }
  
  .header-container {
    padding: 0 10px;
  }
  
  .company-name {
    font-size: 20px;
  }
  
  .platform-name {
    font-size: 14px;
  }
  
  .hamburger-menu {
    display: flex;
  }
  
  .nav-desktop {
    display: none;
  }
  
  .nav-button {
    width: 100%;
    margin-bottom: 8px;
  }
}

@media (max-width: 480px) {
  .company-name {
    font-size: 18px;
  }
  
  .platform-name {
    font-size: 13px;
  }
  
  .nav-mobile {
    width: 85%;
  }
  
  .nav-button-mobile {
    padding: 12px;
    font-size: 14px;
  }
}

/* 无障碍优化 */
.nav-button:focus,
.nav-button-mobile:focus,
.hamburger-menu:focus {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

/* 打印样式优化 */
@media print {
  .root-menu {
    position: static;
  }

  .header {
    background: #0056b3 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .nav-desktop,
  .nav-mobile {
    display: none;
  }
}

/* PC端：显示顶部触发条（钉子） */
@media (min-width: 769px) {
  .menu-trigger-bar {
    display: flex;
  }
}

/* 移动端：不做收起动画，菜单始终完整显示 */
@media (max-width: 768px) {
  .menu-trigger-bar {
    display: none;
  }

  .menu-panel {
    max-height: none !important;
    opacity: 1 !important;
    overflow: visible;
  }
}
</style>
<!-- 批文识别对话框 - 仅管理员可见 -->
<PzwhChatDialog ref="pzwhChatDialog" />
